import { SVGProps } from 'react';

const PlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color="var(--brand-bg-primary)"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    data-palette="PlusIcon">
    <path
      d="M5.16666 5.16666V0.166664H6.83332V5.16666H11.8333V6.83333H6.83332V11.8333H5.16666V6.83333H0.166656V5.16666H5.16666Z"
      fill="currentColor"
    />
  </svg>
);

export default PlusIcon;
